module.exports = __webpack_public_path__ + "static/media/DSC01009-34_Small.e1a70f42.jpg";